/* tslint:disable */
/* eslint-disable */
/**
 * Melco ControlCenter APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlcenterMelcoModelsCreateSupplierProduct
 */
export interface ControlcenterMelcoModelsCreateSupplierProduct {
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoModelsCreateSupplierProduct
     */
    supplier_id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoModelsCreateSupplierProduct
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoModelsCreateSupplierProduct
     */
    code?: string | null;
}

export function ControlcenterMelcoModelsCreateSupplierProductFromJSON(json: any): ControlcenterMelcoModelsCreateSupplierProduct {
    return ControlcenterMelcoModelsCreateSupplierProductFromJSONTyped(json, false);
}

export function ControlcenterMelcoModelsCreateSupplierProductFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlcenterMelcoModelsCreateSupplierProduct {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'supplier_id': !exists(json, 'supplier_id') ? undefined : json['supplier_id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'code': !exists(json, 'code') ? undefined : json['code'],
    };
}

export function ControlcenterMelcoModelsCreateSupplierProductToJSON(value?: ControlcenterMelcoModelsCreateSupplierProduct | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'supplier_id': value.supplier_id,
        'name': value.name,
        'code': value.code,
    };
}


